import { render, staticRenderFns } from "./myInfo.vue?vue&type=template&id=12ae86ce&scoped=true&"
import script from "./myInfo.vue?vue&type=script&lang=js&"
export * from "./myInfo.vue?vue&type=script&lang=js&"
import style0 from "./myInfo.vue?vue&type=style&index=0&id=12ae86ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae86ce",
  null
  
)

export default component.exports